import {Route, Router, Switch} from 'wouter'
import {useHashLocation} from 'wouter/use-hash-location'
import {PageHeader} from './components/ui/page-header'
import {TopMenu} from './components/TopMenu'
import './index.css'
import {ROUTES} from './routes'
import {strictParser} from './router'

export function App() {
    return (
        <Router
            parser={strictParser}
            hook={useHashLocation}
        >
            <TopMenu />
            <main className='pt-14 min-h-screen w-full bg-surface'>
                <div className='max-w-screen-2xl mx-auto px-6 py-16'>
                    <Switch>
                        {ROUTES.map(route => (
                            <Route
                                key={route.path}
                                path={route.path}
                                component={route.component}
                            />
                        ))}
                        <Route>
                            <PageHeader
                                eyebrow='404 / NOT FOUND'
                                title='Page not found'
                            />
                        </Route>
                    </Switch>
                </div>
            </main>
        </Router>
    )
}

export default App
